import { render, staticRenderFns } from "./EditArt.vue?vue&type=template&id=fa78dab2"
import script from "./EditArt.vue?vue&type=script&lang=js"
export * from "./EditArt.vue?vue&type=script&lang=js"
import style0 from "./EditArt.vue?vue&type=style&index=0&id=fa78dab2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports